import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getEventTypeLabel, getTypeBadgeStyle, normalizeEventTypeKey } from '../eventTypes';

const Badge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'badgeStyle',
})(({ badgeStyle, compact }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  minWidth: compact ? 48 : 56,
  padding: compact ? '3px 12px' : '4px 14px',
  borderRadius: 9999,
  backgroundColor: badgeStyle.backgroundColor,
  color: badgeStyle.color,
  fontSize: compact ? '0.75rem' : '0.8125rem',
  fontWeight: 600,
  lineHeight: 1.2,
  letterSpacing: '0.01em',
  whiteSpace: 'nowrap',
}));

const EventTypeBadge = ({ type, compact = false }) => {
  const typeKey = normalizeEventTypeKey(type);
  const label = getEventTypeLabel(typeKey) || type;

  return (
    <Badge badgeStyle={getTypeBadgeStyle(typeKey)} compact={compact}>
      {label}
    </Badge>
  );
};

export default EventTypeBadge;
